<script>
  import { Bell, Mail, Smartphone } from 'lucide-svelte';
  import SettingsCard from './shared/SettingsCard.svelte';

  let emailAlerts = true;
  let pushNotifications = true;
  let weeklySummary = false;

  const checkboxClass = 'h-4 w-4 rounded border-slate-300 text-blue-600 focus:ring-2 focus:ring-blue-100';
</script>

<div class="min-h-full bg-slate-100 p-4 lg:p-6">
  <div class="mx-auto max-w-5xl space-y-4">
    <SettingsCard title="Notification Channels" description="Choose how system alerts are delivered.">
      <span slot="actions" class="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-blue-50 text-blue-700">
        <Bell size={18} />
      </span>

      <div class="grid grid-cols-1 gap-3 md:grid-cols-3">
        <label class="flex min-w-0 items-start gap-3 rounded-xl border border-slate-200 bg-slate-50 p-4">
          <input type="checkbox" bind:checked={emailAlerts} class={`${checkboxClass} mt-1`} />
          <span class="min-w-0">
            <span class="flex items-center gap-2 text-sm font-semibold text-slate-900">
              <Mail size={16} />
              Email alerts
            </span>
            <span class="mt-1 block text-sm text-slate-500">Account and workflow updates.</span>
          </span>
        </label>

        <label class="flex min-w-0 items-start gap-3 rounded-xl border border-slate-200 bg-slate-50 p-4">
          <input type="checkbox" bind:checked={pushNotifications} class={`${checkboxClass} mt-1`} />
          <span class="min-w-0">
            <span class="flex items-center gap-2 text-sm font-semibold text-slate-900">
              <Smartphone size={16} />
              Push notifications
            </span>
            <span class="mt-1 block text-sm text-slate-500">Real-time browser alerts.</span>
          </span>
        </label>

        <label class="flex min-w-0 items-start gap-3 rounded-xl border border-slate-200 bg-slate-50 p-4">
          <input type="checkbox" bind:checked={weeklySummary} class={`${checkboxClass} mt-1`} />
          <span class="min-w-0">
            <span class="flex items-center gap-2 text-sm font-semibold text-slate-900">
              <Bell size={16} />
              Weekly summary
            </span>
            <span class="mt-1 block text-sm text-slate-500">A compact activity digest.</span>
          </span>
        </label>
      </div>
    </SettingsCard>
  </div>
</div>
